let singleProduct = {};


singleProduct.init = () => {
  let $slider = $('.js-single-product');
  let elChildLength = ($slider.children().length > 1) ? true : false;
  let isArrow = (window.innerWidth > 979 && elChildLength) ? true : false;

  if(!$slider) return;

  $slider.flickity({
    pageDots: elChildLength,
    contain: true,
    cellAlign: 'center',
    percentPosition: false,
    dragThreshold: 10,
    prevNextButtons: isArrow,
    groupCells: false,
    freeScroll: false,
    wrapAround: false,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  singleProduct.init();
});



// WEBPACK FOOTER //
// ./scripts/components/single-product.js